const API_URL = process.env.API_URL

export const putQrCodeBouncer = (accountId, id, redirectUrl) =>
    fetch(`${API_URL}/api/QrCodeBouncer/${accountId}/${id}`, {
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            "id": id,
            "accountId": accountId,
            "visitCount": 0,
            "redirectUrl": redirectUrl
        })
    })
